
<div :class="`w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik ${aboutUs ? 'pt-12 1240-bp:pt-28 1240-bp:pb-16' : 'get-in-touch-outer-container'}`">
  <div :class="`w-full ${aboutUs ? 'max-w-1024 mx-5' : 'max-w-1440 mx-5'}`">
    <div :class="`w-full flex flex-col gap-8 1240-bp:flex-row 1240-bp:gap-16`">
      <!-- MAP SECTION -->
      <div class="1240-bp:w-1/2 w-full border bg-white map-border-radius map-border-color">
        <div class="flex flex-col">
          <div class="w-full h-full get-in-touch-map-container">
            <google-maps :apiKey="googleMapsApiKey" class="google-map-border-radius" />
          </div>
          <div>
            <div :class="`flex flex-row justify-between items-center city-state-section ${aboutUs ? 'px-5 py-3 1240-bp:py-5 font-medium' : 'p-5 font-semibold'}`">
              <p>{{ city }}</p>
              <p>{{ state }}</p>
            </div>
            <div class="flex flex-row justify-between items-center h-12 open-map-section p-5">
              <button @click="openGoogleMaps" class="w-full flex flex-row justify-between items-center">
                <p>Open on Maps</p>
                <img class="svg-gray h-6" src="@/images/get-in-touch/open-map-arrow.svg" alt="Open map">
              </button>
            </div>
            <div class="flex flex-row justify-between items-center p-5">
              <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/solutions/container-modifications">
                <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/modifications.svg" alt="Container modifications">
                <p>Container</p>
                <p>Modifications</p>
              </a>
              <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/containers-for-sale">
                <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/sales.svg" alt="Container sales">
                <p>Container</p>
                <p>Sales</p>
              </a>
              <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/containers-for-rent">
                <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/rental.svg" alt="Container rental">
                <p>Container</p>
                <p>Rental</p>
              </a>
              <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/solutions/refrigerated-containers">
                <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/refrigerated.svg" alt="Refrigerated containers">
                <p>Refrigerated</p>
                <p>Containers</p>
              </a>
              <a :class="`${aboutUs ? 'about-us-map-links': 'map-links'}`" href="/solutions/portable-offices">
                <img :class="`svg-gray mb-1 1240-bp:mb-2 h-6 ${aboutUs ? '1240-bp:h-6': '1240-bp:h-8'}`" src="@/images/get-in-touch/offices.svg" alt="Portable officies">
                <p>Portable</p>
                <p>Officies</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- GET IN TOUCH SECTION -->
      <div class="1240-bp:w-1/2 w-full">
    
        <div class="w-full flex flex-col justify-between h-full gap-4 1240-bp:gap-0">
          <div :class="`${aboutUs ? '1240-bp:mb-4' : ''}`">
            <h1 class="get-in-touch-h1">Get in touch </h1>
          </div>
          <div :class="`w-full flex flex-col justify-between gap-3 ${aboutUs ? '' : '1240-bp:flex-row'}`">
            <div class="flex flex-col w-full gap-2">
              <label class="get-in-touch-label" for="first_name">
                First Name <span class="get-in-touch-required-field">*</span>
              </label>
              <input
                class="get-in-touch-input min-w-full"
                v-model="lead.firstName"
                name="first_name"
                id="first_name"
                type="text"
              >
            </div>
            <div class="flex flex-col w-full gap-2">
              <label class="get-in-touch-label" for="last_name">
                Last Name <span class="get-in-touch-required-field">*</span>
              </label>
              <input
                class="get-in-touch-input min-w-full"
                v-model="lead.lastName"
                name="last_name"
                id="last_name"
                type="text"
              >
            </div>
          </div>
          <div :class="['w-full flex flex-col 1240-bp:flex-row justify-between gap-3', { '1240-bp:my-2': aboutUs }]" >
            <div class="flex flex-col w-full gap-2">
              <label class="get-in-touch-label" for="email">
                Email <span class="get-in-touch-required-field">*</span>
              </label>
              <input
                class="get-in-touch-input min-w-full"
                v-model="lead.email"
                name="email"
                id="email"
                type="email"
              >
            </div>
          </div>
          <div :class="`w-full flex flex-col justify-between gap-3 ${aboutUs ? '' : '1240-bp:flex-row'}`">
            <div class="flex flex-col w-full gap-2">
              <label class="get-in-touch-label" for="phone">
                Phone <span class="get-in-touch-required-field">*</span>
              </label>
              <input
                class="get-in-touch-input min-w-full"
                v-model="lead.phone"
                name="phone"
                id="phone"
                type="text"
              >
            </div>
            <div class="w-full flex flex-col gap-2 relative">
              <label class="get-in-touch-label" for="zipcode">
                Zip Code <span class="get-in-touch-required-field">*</span>
              </label>
              <input
                class="get-in-touch-input get-in-touch-zip-code min-w-full"
                v-model="lead.zipcode"
                name="zipcode"
                id="zipcode"
                type="text"
              >
              <img class="absolute left-3 pr-3 transform -translate-y-1/2 h-6" style="top: 70%;" src="@/images/get-in-touch/current-location.svg" alt="Zip code">
            </div>
          </div>
          <div :class="['w-full flex flex-col 1240-bp:flex-row justify-between gap-3', { '1240-bp:my-4': aboutUs }]" >
            <div class="flex flex-col w-full gap-2">
              <label class="get-in-touch-label" for="notes">Message (Optional)</label>
              <textarea
                :class="`get-in-touch-input min-w-full ${aboutUs ? 'get-in-touch-textarea-about-us' : 'get-in-touch-textarea'}`"
                v-model="lead.notes"
                id="notes"
                placeholder="Type your message..."
              >
              </textarea>
            </div>
          </div>
          <div class="w-full flex flex-col 1240-bp:flex-row justify-between gap-3">
            <div class="w-full 1240-bp:w-3/4 flex flex-row items-center">
              <input
                class="get-in-touch-checkbox"
                v-model="lead.smsConsent"
                name="smsConsent"
                id="smsConsent"
                type="checkbox"
              >
              <label :class="`${aboutUs ? 'get-in-touch-consent' : 'get-in-touch-label'} pl-2 w-full`" for="smsConsent">
                I consent to receive SMS text messages from this business.
              </label>
            </div>
            <div class="w-full 1240-bp:w-1/4 flex flex-row justify-center">
              <button
                :class="[`${aboutUs ? 'about-us-get-in-touch-button': 'get-in-touch-button'} flex items-center justify-center gap-1`, isFormValid ? 'bg-themeButton' : 'bg-themeButton-light cursor-not-allowed']"
                :disabled="!isFormValid"
                @click="validateForm"
              >
                <p>{{ buttonText }}</p>
                <img class="h-5" v-if="buttonText == 'Message sent'"  src="@/images/get-in-touch/check-circle.svg">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
